import { AllIcon, IconType } from '@mm/icons';
import {
  ChatBlasterIcon,
  DripCampaignIcon,
  LegacyMessengerAdIcon,
  MessengerAdIcon,
  RssBlasterIcon,
  SponsoredMessageIcon,
} from '@mm/icons/CampaignIcons';
import { CtmAdIndexModel } from '@mm/state/model/CtmAdModel';
import { MessengerAdModel } from '@mm/state/model/MessengerAdModel';
import RssFeedModel from '@mm/state/model/RssFeedModel';
import { SponsoredMessageModel } from '@mm/state/model/SponsoredMessageModel';
import { CampaignTypeWithMappedPurposeAndDisplayStatus } from '@mm/state/selectors/campaignSelectors';

export type UIFilterCampaignTimeType = 'week' | 'month';

const UIFilterCampaignKind = [
  'all',
  'chat_blaster',
  'drip_campaigns',
  'ctm_ads',
  'legacy_messenger_ads',
  'sponsored_messages',
  'rss_blasts',
  'automation',
] as const;

type UIFilterCampaignKindTuple = typeof UIFilterCampaignKind;
export type UIFilterCampaignKindType = UIFilterCampaignKindTuple[number];

export function isCampaignKind(s: any): s is UIFilterCampaignKindType {
  return UIFilterCampaignKind.includes(s);
}

export function isTimeKind(s: any): s is UIFilterCampaignTimeType {
  return ['week', 'month'].includes(s);
}

export type UICampaignType = {
  name: string;
  icon: IconType;
};

export const campaignTypeByKind: Record<
  UIFilterCampaignKindType,
  UICampaignType
> = {
  all: {
    name: 'All',
    icon: AllIcon,
  },
  chat_blaster: {
    name: 'Chat Blaster',
    icon: ChatBlasterIcon,
  },
  drip_campaigns: {
    name: 'Drip Campaigns',
    icon: DripCampaignIcon,
  },
  ctm_ads: {
    name: 'Click-to-messenger Ads',
    icon: MessengerAdIcon,
  },
  legacy_messenger_ads: {
    name: 'Legacy Messenger Ads',
    icon: LegacyMessengerAdIcon,
  },
  sponsored_messages: {
    name: 'Sponsored Messages',
    icon: SponsoredMessageIcon,
  },
  rss_blasts: {
    name: 'RSS Blasts',
    icon: RssBlasterIcon,
  },
  automation: {
    name: '',
    icon: () => '',
  },
};

export type CampaignDataType =
  | CampaignTypeWithMappedPurposeAndDisplayStatus
  | MessengerAdModel
  | CtmAdIndexModel
  | SponsoredMessageModel
  | RssFeedModel;

export type CampaignDataTypeWithUiKind = CampaignDataType & {
  uiFilterKind: UIFilterCampaignKindType;
};

export type CampaignsMapType = {
  dripCampaigns: CampaignTypeWithMappedPurposeAndDisplayStatus;
  chatBlasters: CampaignTypeWithMappedPurposeAndDisplayStatus;
  rssFeeds: RssFeedModel[];
  sponsoredMessages: SponsoredMessageModel[];
  legacyAds: MessengerAdModel[];
  ctmAds: CtmAdIndexModel[];
};
